import React from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';

export default function Header() {
    const navigate = useNavigate();
    return (
        <>
            <div className="flex flex-wrap align-items-center justify-content-end field p-2 header m-0">
                <span className="text-xl text-900 font-bold mr-auto pl-3" >Ahir Vishal</span >
                <Button icon="pi pi-download" label="Download Resume" className='text-black-alpha-50' text onClick={() => navigate("/")} />
            </div>
        </>
    );
}
